var map = {
	"./Breadcrumb.vue": "Y3Dv",
	"./Vschart.vue": "zrFu"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "oiHp";


//////////////////
// WEBPACK FOOTER
// ./src/components/widgets nonrecursive \.vue$
// module id = oiHp
// module chunks = 1